<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3 d-none">
          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown">
            <li><span class="dropdown-item" @click="activeComponent = 'main'">Main</span></li>
          </ul>
        </div>
        <span class="ml-3"><img class="heading-icon mr-2" src="~@/assets/device_hub_icon.svg"/> Inspector</span>
        <span class="text-primary ml-3">
          {{ $parent.activeComponentTitle }}
        </span>
        <div class="btn-menu-wrapper navbar navbar-expand-lg">
          <ul class="navbar-nav">
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'main'"
                    :class="{'active':activeComponent == 'main'}">
                Main
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">
          <div class="row">
            <div class="col-9">
              <maininspector v-if="activeComponent == 'main'"></maininspector>
            </div>

            <div v-if="selectedImage" class="col-3 position-relative">
              <h4 v-if="selectedImage">{{ selectedImage.objectName }}</h4>
              <div class="selected-char-imgwrap mr-4">
                <img
                  :src="
                    selectedImage.objectUrl
                  "
                  style="width:100%"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import maininspector from '../inspector-components/media-images/maininspector'
import { mapState } from 'vuex'

export default {
  name: 'imagesInspector',
  data () {
    return {
      activeComponent: 'main',
      selectedImage: null
    }
  },
  watch: {
    characters (val) {
      for (let i = 0; i < val.length; i++) {
        const char = val[i]
        if (char.active) {
          this.selectedImage = char
        }
      }
    }
  },
  components: {
    maininspector
  },
  mounted() {
    for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.selectedImage = char
        }
      }
  },
  computed: {
    ...mapState(['characters'])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/imagesInspector.vue